import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import { Badge, Box, Grid, IconButton, ListItemButton, Typography } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { BiSolidDollarCircle } from 'react-icons/bi';
import { FaChartPie, FaCode, FaServer, FaStore, FaUsersCog } from "react-icons/fa";
import { IoIosPeople } from "react-icons/io";
import { MdInterests } from 'react-icons/md';
import { RiDatabase2Fill, RiGitBranchFill } from 'react-icons/ri';
import { TiChartLine, TiLocation } from 'react-icons/ti';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CustomTooltip } from '../Components/Settings/Organization';
import { CONFIG_APP_BASE_COMPANY, CONFIG_APP_PRIMARY_DARK_COLOR, CONFIG_APP_PRIMARY_LIGHT_COLOR } from '../configApp';

const urlsList = [
  {
    url: '/teamboard', title: "Home",
    icon: <HomeIcon style={{ fill: "#160044", fontSize: "25px", }} />,
    iconWhite: <HomeIcon style={{ fill: "#fff", fontSize: "25px", }} />,
    iconDark: <HomeIcon style={{ fill: "gray", fontSize: "25px", }} />,
  },
  {
    url: '/organizations', title: "Organizations",
    className: "demo__orgs_tab",
    icon: <IoIosPeople style={{ fill: "#160044", fontSize: "25px" }} />,
    iconWhite: <IoIosPeople style={{ fill: "#fff", fontSize: "25px" }} />,
    iconDark: <IoIosPeople style={{ fill: "gray", fontSize: "25px" }} />,
  },
  {
    url: '/workloads', title: "Workloads",
    className: "demo__workload_tab",
    icon: <RiGitBranchFill style={{ color: "#160044", fontSize: "25px" }} />,
    iconWhite: <RiGitBranchFill style={{ color: "#fff", fontSize: "25px" }} />,
    iconDark: <RiGitBranchFill style={{ color: "gray", fontSize: "25px" }} />,
  },
  {
    url: '/apps', title: "Apps",
    className: "demo__apps_tab",
    icon: <FaServer style={{ fill: "#160044", fontSize: "20px", margin: "3px" }} />,
    iconWhite: <FaServer style={{ fill: "#fff", fontSize: "20px", margin: "3px" }} />,
    iconDark: <FaServer style={{ fill: "gray", fontSize: "20px", margin: "3px" }} />,
  },
  {
    url: '/sites', title: "Sites",
    className: "demo__site",
    icon: <FaCode style={{ fill: "#160044", fontSize: "20px", margin: "3px" }} />,
    iconWhite: <FaCode style={{ fill: "#fff", fontSize: "20px", margin: "3px" }} />,
    iconDark: <FaCode style={{ fill: "gray", fontSize: "20px", margin: "3px" }} />,
  },
  {
    url: '/databases', title: "Databases",
    className: "demo__database",
    icon: <RiDatabase2Fill style={{ fill: "#160044", fontSize: "25px" }} />,
    iconWhite: <RiDatabase2Fill style={{ fill: "#fff", fontSize: "25px" }} />,
    iconDark: <RiDatabase2Fill style={{ fill: "gray", fontSize: "25px" }} />,
  },
  {
    url: '/location', title: "Locations",
    className: "demo_location",
    icon: <TiLocation style={{ fill: "#160044", fontSize: "25px" }} />,
    iconWhite: <TiLocation style={{ fill: "#fff", fontSize: "25px" }} />,
    iconDark: <TiLocation style={{ fill: "gray", fontSize: "25px" }} />,
  },
  {
    url: '/analytics', title: "User Analytics",
    className: "demo_analytics",
    icon: <FaChartPie style={{ fill: "#160044", fontSize: "20px", margin: "3px" }} />,
    iconWhite: <FaChartPie style={{ fill: "#fff", fontSize: "20px", margin: "3px" }} />,
    iconDark: <FaChartPie style={{ fill: "gray", fontSize: "20px", margin: "3px" }} />,
  },
  {
    url: '/Cost-Monitoring', title: "Cost Monitoring",
    className: "demo_cost_monitoring",
    icon: <BiSolidDollarCircle style={{ fill: "#160044", fontSize: "25px", }} />,
    iconWhite: <BiSolidDollarCircle style={{ fill: "#fff", fontSize: "25px", }} />,
    iconDark: <BiSolidDollarCircle style={{ fill: "gray", fontSize: "25px", }} />,
  },
  {
    url: '/tools', title: "Tools",
    icon: <MdInterests style={{ fill: "#160044", fontSize: "25px" }} />,
    iconWhite: <MdInterests style={{ fill: "#fff", fontSize: "25px" }} />,
    iconDark: <MdInterests style={{ fill: "gray", fontSize: "25px" }} />,
  },
  {
    url: '/activity', title: "Activity",
    className: "demo_acivity",
    icon: <TiChartLine style={{ fill: "#160044", fontSize: "25px" }} />,
    iconWhite: <TiChartLine style={{ fill: "#fff", fontSize: "25px" }} />,
    iconDark: <TiChartLine style={{ fill: "gray", fontSize: "25px" }} />,
  },
  {
    url: '/marketplace',
    title: "OpenHub",
    secondary: "Marketplace", // Add this line
    className: "demo_market_place",
    icon: <FaStore style={{ fill: "#160044", fontSize: "20px", margin: "3px" }} />,
    iconWhite: <FaStore style={{ fill: "#fff", fontSize: "20px", margin: "3px" }} />,
    iconDark: <FaStore style={{ fill: "gray", fontSize: "20px", margin: "3px" }} />,
  }
  ,
  {
    url: '/members', title: "Members",
    className: "demo_member",
    icon: <FaUsersCog style={{ fill: "#160044", fontSize: "20px", margin: "3px" }} />,
    iconWhite: <FaUsersCog style={{ fill: "#fff", fontSize: "20px", margin: "3px" }} />,
    iconDark: <FaUsersCog style={{ fill: "gray", fontSize: "20px", margin: "3px" }} />,
  },
  {
    url: '/settings/account', title: "Settings",
    className: "demo__settings",
    icon: <SettingsIcon style={{ fill: "#160044", fontSize: "25px", }} />,
    iconWhite: <SettingsIcon style={{ fill: "#fff", fontSize: "25px", }} />,
    iconDark: <SettingsIcon style={{ fill: "gray", fontSize: "25px", }} />,
  },
];

export function MainListItems(props) {
  return (
    <>
      {urlsList.map((e, i) => {
        // Hide "Sites" and "Cost Monitoring" if CONFIG_APP_BASE_COMPANY is "zeke"
        if (CONFIG_APP_BASE_COMPANY === "zeke" && (e.title === "Sites" || e.title === "Cost Monitoring" || e.title === "Tools")) {
          return null;
        }
        return (
          <div key={i} className={e.className ? e.className : "undefined"}>
            <Link to={e.url} style={{ textDecoration: "none", color: "#111" }}>
              <ListItemButton style={{ borderRadius: "24px", width: "220px", marginLeft: "10px", marginRight: "10px", marginBottom: "0px" }}>
                <CustomTooltip title={e.title} arrow placement="right-start">
                  <ListItemIcon>
                    {e.icon}
                  </ListItemIcon>
                </CustomTooltip>
                <ListItemText
                  primary={<span style={{ fontWeight: false ? "bold" : "normal" }}>{e.title}</span>}
                  secondary={e.secondary ? <span style={{ fontSize: '0.75rem', color: '#888' }}>{e.secondary}</span> : null}
                />

              </ListItemButton>
            </Link>
          </div>
        );
      })}
    </>
  );
};

export function MainDarkListItems() {
  return (
    <>
      {urlsList.map((e, i) => {
        // Hide "Sites" and "Cost Monitoring" if CONFIG_APP_BASE_COMPANY is "zeke"
        if (CONFIG_APP_BASE_COMPANY === "zeke" && (e.title === "Sites" || e.title === "Cost Monitoring" || e.title === "Tools")) {
          return null;
        }
        return (
          <div key={i} className={e.className ? e.className : "undefined"}>
            <Link to={e.url} style={{ textDecoration: "none", color: "#ededed" }}>
              <ListItemButton style={{ borderRadius: "24px", width: "220px", marginLeft: "10px", marginRight: "10px", marginBottom: "0px" }}>
                <CustomTooltip title={e.title} arrow placement="right-start">
                  <ListItemIcon>
                    {e.iconDark}
                  </ListItemIcon>
                </CustomTooltip>
                <ListItemText
                  primary={<span style={{ fontWeight: false ? "bold" : "normal" }}>{e.title}</span>}
                  secondary={e.secondary ? <span style={{ fontSize: '0.75rem', color: '#888' }}>{e.secondary}</span> : null}
                />
              </ListItemButton>
            </Link>
          </div>
        );
      })}
    </>
  );
};

export function NewListItems({ hover }) {
  let history = useHistory();
  const [selectedTab, setselectedTab] = useState(0);
  const isDarkTheme = useTheme().palette.mode === 'dark';

  const handleOnClick = (value, item) => {
    setselectedTab(value);
    history.push(item.url);
  };

  useEffect(() => {
    let value = window.location.href.split("/");

    if (value[value.length - 1] === "location") {
      document.title = "Location";
      setselectedTab(6);
      return;
    }

    if (value[value.length - 1] === "sites" || value[value.length - 1] === "Cost-Monitoring") {
      if (CONFIG_APP_BASE_COMPANY === "zeke") {
        return;
      }
    }

    if (value[value.length - 1] === "account") {
      document.title = "Settings";
      setselectedTab(13);
      return;
    }

    if (value[value.length - 1] === "teamboard") {
      document.title = "Home";
      setselectedTab(0);
      return;
    }

  }, [window.location.href]);

  return (
    <div>
      <Grid container direction="column" justifyContent="center" alignItems="flex-start" spacing={0}>
        {urlsList.map((e, i) => {
          if (CONFIG_APP_BASE_COMPANY === "zeke" && (e.title === "Sites" || e.title === "Cost Monitoring" || e.title === "Tools")) {
            return null;
          }

          const isMarketplace = e.url === '/marketplace';

          return (
            <div key={i} className={e.className ? e.className : "undefined"}>
              <Grid item onClick={() => handleOnClick(i, e)}>
                {isMarketplace ? (
                  hover ? (
                    // Expanded Card on Hover
                    <Box
                      sx={{
                        ml: 3, mr: 0, p: 2,
                        borderRadius: "12px",
                        width: 180,
                        backgroundColor: selectedTab === i
                          ? (isDarkTheme ? CONFIG_APP_PRIMARY_DARK_COLOR : CONFIG_APP_PRIMARY_LIGHT_COLOR)
                          : (isDarkTheme ? '#111' : '#f9f9f9'),
                        color: isDarkTheme ? '#fff' : '#000',
                        cursor: 'pointer',
                        boxShadow: selectedTab === i ? '0 0 10px rgba(0,215,255,0.5)' : 'none',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                          transform: 'scale(1.05)',
                          border: '1px solid #00d7ff',
                          boxShadow: '0 0 10px rgba(0,215,255,0.3)',
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Badge
                          variant={hover ? "standard" : "dot"}
                          color="primary"
                          overlap="circular"
                          badgeContent={hover ? 'NEW' : undefined}
                          sx={{
                            '& .MuiBadge-badge': {
                              top: 2,
                              right: 2,
                              height: hover ? 'auto' : 8,
                              minWidth: hover ? 'auto' : 8,
                              padding: hover ? '0 4px' : 0,
                              fontSize: hover ? '0.55rem' : 0,
                              borderRadius: hover ? '4px' : '50%',
                              backgroundColor: '#00d7ff',
                              color: '#fff',
                            },
                          }}
                        >
                          {selectedTab === i ? (isDarkTheme ? e.iconDark : e.iconWhite) : 
                          (isDarkTheme ? e.iconDark : e.icon)}
                        </Badge>


                      </Box>
                       {selectedTab === i ? <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 'bold',
                          fontSize: '0.85rem',
                          color: (isDarkTheme ? '#000' : '#fff'),
                        }}
                      >
                        OpenHub
                      </Typography>:
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 'bold',
                          fontSize: '0.85rem',
                          color: (isDarkTheme ? '#fff' : '#000'),
                        }}
                      >
                        OpenHub
                      </Typography>}
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.7rem',
                          color: isDarkTheme ? '#aaaaaa' : '#888888',
                        }}
                      >
                       Open Source Marketplace
                      </Typography>
                    </Box>
                  ) : (
                    // Minimal IconButton with dot badge (non-hover)
                    <IconButton sx={{
                      ml: 3, mr: 3, borderRadius: "12px",
                      borderBottom: selectedTab === i ? "2px solid #00d7ff" : undefined,
                      background: selectedTab === i ? CONFIG_APP_PRIMARY_LIGHT_COLOR : "transparent",
                      transition: 'transform 0.2s ease-in-out',
                      '&:hover': {
                        backgroundColor: selectedTab === i ? "#16004496" : '#f4f4f4',
                        transform: 'scale(1.1)'
                      }
                    }}>
                      <Badge
                        variant="dot"
                        color="primary"
                        overlap="circular"
                        sx={{
                          '& .MuiBadge-badge': {
                            top: 2,
                            right: 2,
                            height: 8,
                            minWidth: 8,
                            borderRadius: '50%',
                            backgroundColor: '#00d7ff',
                          },
                        }}
                      >
                        {selectedTab === i ? (isDarkTheme ? e.iconWhite : e.iconWhite) : (isDarkTheme ? e.iconDark : e.icon)}
                      </Badge>
                    </IconButton>
                  )
                ) : (
                  // All other items render normally
                  <>
                    {isDarkTheme ?
                      <IconButton sx={{
                        ml: 3, mr: hover ? 0 : 3, borderRadius: "12px",
                        borderBottom: selectedTab === i ? "2px solid #00d7ff" : undefined,
                        background: selectedTab === i ? CONFIG_APP_PRIMARY_DARK_COLOR : "transparent",
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': { backgroundColor: selectedTab === i ? "#e3f2fd" : '#000', transform: 'scale(1.05)' }
                      }}>
                        {selectedTab === i ? e.icon : e.iconDark}
                      </IconButton>
                      :
                      <IconButton sx={{
                        ml: 3, mr: hover ? 0 : 3, borderRadius: "12px",
                        borderBottom: selectedTab === i ? "2px solid #00d7ff" : undefined,
                        background: selectedTab === i ? CONFIG_APP_PRIMARY_LIGHT_COLOR : "transparent",
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': { backgroundColor: selectedTab === i ? "#16004496" : '#f4f4f4', transform: 'scale(1.1)' }
                      }}>
                        {selectedTab === i ? e.iconWhite : e.icon}
                      </IconButton>
                    }

                    {hover && (
                      <Typography
                        variant="body2"
                        sx={{
                          cursor: "pointer",
                          display: 'inline-block',
                          marginLeft: '8px',
                          color: isDarkTheme ? '#ffffff' : '#000000',
                          fontWeight: selectedTab === i ? 'bold' : 'normal',
                          fontSize: selectedTab === i ? '0.9rem' : '0.8rem',
                          transition: 'transform 0.2s ease-in-out',
                          position: 'relative',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            '&::after': {
                              transform: 'scaleX(1)',
                            }
                          },
                          '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            height: '2px',
                            backgroundColor: isDarkTheme ? '#00d7ff' : '#160044',
                            transform: 'scaleX(0)',
                            transition: 'transform 0.3s ease-in-out',
                          },
                        }}
                      >
                        {e.title}
                        {e.secondary && (
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: '0.65rem',
                              color: isDarkTheme ? '#aaaaaa' : '#888888',
                              display: 'block',
                              lineHeight: 1.2,
                            }}
                          >
                            {e.secondary}
                          </Typography>
                        )}
                      </Typography>
                    )}
                  </>
                )}
              </Grid>
            </div>
          );


        })}

      </Grid>
    </div>
  );
};

